// /src/components/TabbedFilesAndRecords.js
import React, { useState } from "react";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import FilesTable from "./FilesTable";
import RecordsTable from "./RecordsTable";
import RecordDetails from "./RecordDetails";
import FileImportDetails from "./FileImportDetails";

function TabbedFilesAndRecords() {
  const [tab, setTab] = useState(0);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedRecord, setSelectedRecord] = useState(null);

  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <Box>
      <Tabs value={tab} onChange={handleChange}>
        <Tab label="Files" />
        {selectedFile && <Tab label={`Records: ${selectedFile.file_name}`} />}
        {selectedRecord && <Tab label={`Record: ${selectedRecord.email || selectedRecord.id}`} />}
      </Tabs>

      {/* Files Tab */}
      {tab === 0 && (
        <Box mt={2}>
          <FilesTable
            onFileSelect={(file) => {
              setSelectedFile(file);
              setSelectedRecord(null); // reset record when new file selected
              setTab(1); // switch to Records tab
            }}
          />
        </Box>
      )}

      {/* Records Tab */}
      {tab === 1 && selectedFile && (
        <Box mt={2}>
          <Typography variant="h6" gutterBottom>
            Records for {selectedFile.file_name}
          </Typography>
          <FileImportDetails fileId={selectedFile.fileid} />
          <RecordsTable
            fileId={selectedFile.fileid}
            filename={selectedFile.file_name}
            onRecordSelect={(record) => {
              setSelectedRecord(record);
              setTab(2); // switch to Record Details tab
            }}
          />
        </Box>
      )}

      {/* Record Details Tab */}

      {tab === 2 && selectedRecord && (
        <Box mt={2}>
          <RecordDetails record={selectedRecord} />
        </Box>
      )}
    </Box>
  );
}

export default TabbedFilesAndRecords;
